import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDiagLabPanels } from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import { getEntities as getDiaglabBills } from 'app/entities/diaglab-bill/diaglab-bill.reducer';
import { getEntities as getDiaglabPricings } from 'app/entities/diaglab-pricing/diaglab-pricing.reducer';
import { getEntities as getUserLabTestItems } from 'app/entities/user-lab-test-item/user-lab-test-item.reducer';
import { getEntities as getPaymentSchemes } from 'app/entities/payment-scheme/payment-scheme.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { createEntity, getEntity, reset, updateEntity } from './diaglab-bill-item.reducer';

export const DiaglabBillItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const diagLabPanels = useAppSelector(state => state.diagLabPanel.entities);
  const diaglabBills = useAppSelector(state => state.diaglabBill.entities);
  const diaglabPricings = useAppSelector(state => state.diaglabPricing.entities);
  const userLabTestItems = useAppSelector(state => state.userLabTestItem.entities);
  const paymentSchemes = useAppSelector(state => state.paymentScheme.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const diaglabBillItemEntity = useAppSelector(state => state.diaglabBillItem.entity);
  const loading = useAppSelector(state => state.diaglabBillItem.loading);
  const updating = useAppSelector(state => state.diaglabBillItem.updating);
  const updateSuccess = useAppSelector(state => state.diaglabBillItem.updateSuccess);

  const handleClose = () => {
    navigate(`/diaglab-bill-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDiagLabPanels({}));
    dispatch(getDiaglabBills({}));
    dispatch(getDiaglabPricings({}));
    dispatch(getUserLabTestItems({}));
    dispatch(getPaymentSchemes({}));
    dispatch(getClinicalDictionaries({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.discount !== undefined && typeof values.discount !== 'number') {
      values.discount = Number(values.discount);
    }
    if (values.paidAmount !== undefined && typeof values.paidAmount !== 'number') {
      values.paidAmount = Number(values.paidAmount);
    }

    const entity = {
      ...diaglabBillItemEntity,
      ...values,
      panel: diagLabPanels.find(it => it.id.toString() === values.panel?.toString()),
      diaglabBill: diaglabBills.find(it => it.id.toString() === values.diaglabBill?.toString()),
      diaglabPricing: diaglabPricings.find(it => it.id.toString() === values.diaglabPricing?.toString()),
      labTestItem: userLabTestItems.find(it => it.id.toString() === values.labTestItem?.toString()),
      scheme: paymentSchemes.find(it => it.id.toString() === values.scheme?.toString()),
      accessEntry: clinicalDictionaries.find(it => it.id.toString() === values.accessEntry?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...diaglabBillItemEntity,
          panel: diaglabBillItemEntity?.panel?.id,
          diaglabBill: diaglabBillItemEntity?.diaglabBill?.id,
          diaglabPricing: diaglabBillItemEntity?.diaglabPricing?.id,
          labTestItem: diaglabBillItemEntity?.labTestItem?.id,
          scheme: diaglabBillItemEntity?.scheme?.id,
          accessEntry: diaglabBillItemEntity?.accessEntry?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.diaglabBillItem.home.createOrEditLabel" data-cy="DiaglabBillItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.diaglabBillItem.home.createOrEditLabel">Create or edit a DiaglabBillItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="diaglab-bill-item-id"
                  label={translate('tinyMedicRestApp.diaglabBillItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.price')}
                id="diaglab-bill-item-price"
                name="price"
                data-cy="price"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.active')}
                id="diaglab-bill-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.cursor')}
                id="diaglab-bill-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.lastupdated')}
                id="diaglab-bill-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.microSec')}
                id="diaglab-bill-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.timestampentry')}
                id="diaglab-bill-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.statusCode')}
                id="diaglab-bill-item-statusCode"
                name="statusCode"
                data-cy="statusCode"
                type="text"
                validate={{
                  maxLength: { value: 50, message: translate('entity.validation.maxlength', { max: 50 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.cancelledReason')}
                id="diaglab-bill-item-cancelledReason"
                name="cancelledReason"
                data-cy="cancelledReason"
                type="text"
                validate={{
                  maxLength: { value: 300, message: translate('entity.validation.maxlength', { max: 300 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.discount')}
                id="diaglab-bill-item-discount"
                name="discount"
                data-cy="discount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.paidAmount')}
                id="diaglab-bill-item-paidAmount"
                name="paidAmount"
                data-cy="paidAmount"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.diaglabBillItem.groupPanelId')}
                id="diaglab-bill-item-groupPanelId"
                name="groupPanelId"
                data-cy="groupPanelId"
                type="text"
              />
              <ValidatedField
                id="diaglab-bill-item-panel"
                name="panel"
                data-cy="panel"
                label={translate('tinyMedicRestApp.diaglabBillItem.panel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-bill-item-diaglabBill"
                name="diaglabBill"
                data-cy="diaglabBill"
                label={translate('tinyMedicRestApp.diaglabBillItem.diaglabBill')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabBills
                  ? diaglabBills.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-bill-item-diaglabPricing"
                name="diaglabPricing"
                data-cy="diaglabPricing"
                label={translate('tinyMedicRestApp.diaglabBillItem.diaglabPricing')}
                type="select"
              >
                <option value="" key="0" />
                {diaglabPricings
                  ? diaglabPricings.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-bill-item-labTestItem"
                name="labTestItem"
                data-cy="labTestItem"
                label={translate('tinyMedicRestApp.diaglabBillItem.labTestItem')}
                type="select"
                required
              >
                <option value="" key="0" />
                {userLabTestItems
                  ? userLabTestItems.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="diaglab-bill-item-scheme"
                name="scheme"
                data-cy="scheme"
                label={translate('tinyMedicRestApp.diaglabBillItem.scheme')}
                type="select"
              >
                <option value="" key="0" />
                {paymentSchemes
                  ? paymentSchemes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="diaglab-bill-item-accessEntry"
                name="accessEntry"
                data-cy="accessEntry"
                label={translate('tinyMedicRestApp.diaglabBillItem.accessEntry')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/diaglab-bill-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DiaglabBillItemUpdate;
